import React from 'react';
import { CardFull } from '../../widgets/Cards';
import { connect } from 'react-redux';
import { fetchPathologys } from '../../../actions';
import Lipid from './Pathology/Lipid';
import Kidney from './Pathology/Kidney';
import Liver from './Pathology/Liver';
import Bone from './Pathology/Bone';
import Glucose from './Pathology/Glucose';
import Thyroid from './Pathology/Thyroid';
import Inflammatory from './Pathology/Inflammatory';
import Hema from './Pathology/Hema';
import Iron from './Pathology/Iron';

class Pathology extends React.Component {

    componentDidMount() {
        this.props.fetchPathologys(this.props.id);
    }

    render() {

        return (
            <CardFull title='Pathology Monitoring'>

                <Lipid/>
                <Kidney />
                <Liver />
                <Glucose />
                <Thyroid />
                <Bone />
                <Inflammatory />
                <Hema />
                <Iron />
            </CardFull>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        pathologys : Object.values(state.pathologys),
    }
}

export default connect(mapStateToProps, {fetchPathologys})(Pathology);

